import Box from "@mui/material/Box";
import { colorPalette } from '../../colorPalette';
import React from 'react';
import { squareIconStyle } from './SquareIcon.style';
export const SquareIcon = ({ icon, color, backgroundColor }) => {
    return (React.createElement(Box, { sx: Object.assign(Object.assign({}, squareIconStyle), { color: color ? color : colorPalette.gray500, backgroundColor: backgroundColor ? backgroundColor : colorPalette.gray100 }) }, icon));
};
